import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const DetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  // background-color: #f3f5f7;
`;

const TopCard = styled.div`
`;

const TopSection = styled.div`
display: grid;
box-shadow: rgba(0, 0, 0, 0.05) 0px 7px 10px;
  grid-template-columns: 400px .8fr 1fr;
  gap: 2rem;
  padding: 2rem;
  border-radius: 12px;
  background-color: #ffffff;
  z-index: 9;
  
    position: relative;
  
  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`;

const ScoreColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SemiCircleProgress = styled.div`
  position: relative;
  width: 100%;
  height: 240px;
  margin-bottom: 1rem;
`;

const ScoreText = styled.div`
  position: absolute;
  top: 65%;
  left: 50%;
  transform: translate(-50%, -20%);
  text-align: center;
`;

const Score = styled.div`
  font-size: 3rem;
  font-weight: 600;
  color: #1f2937;
  line-height: 1;
`;

const MaxScore = styled.span`
  font-size: 1.5rem;
  font-weight: 400;
  color: #9ca3af;
`;

const StatusBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: -1rem;
  font-size: .9rem;
  color: ${props => props.gaugeColor || '#10b981'};
  font-weight: 600;
  padding: 0.3rem 1rem;
  border-radius: 20px;
  border:1px solid;
  border-color: ${props => props.gaugeColor ? `${props.gaugeColor}` : '#10b981'};
  
  &::before {
    content: '●';
    font-size: 1.rem;
  }
`;

const StatusText = styled.div`
  font-size: 0.875rem;
  color: #6b7280;
  text-align: center;
  margin-top: 0.5rem;
`;

const SummaryColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const SummaryContent = styled.div`
  border: 2px solid ${props => props.isPassed ? '#00b928' : '#ff4352'};
  background: ${props => props.isPassed ? '#f2fbf4' : '#ff43520d'};
  border-radius: 12px;
  padding: 2rem;
  height : 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position:relative;
`;

const SummaryContentTopContent = styled.div`
  // border: 2px solid #d1fae5;
  border-radius: 12px;
  padding: 2rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const SummaryContentBottomContent = styled.div`
width: 80%;
  border: 2px solid #d1fae5;
  border-radius: 12px;
  padding: 2rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
  const SummaryText = styled.div`
    font-size: 1rem;
    color: #ff4352;
    line-height: 1.6;
    margin-bottom: 1rem;
    font-weight: 500;
  `;
  const SummaryTextIcon = styled.div`
    position:absolute;
    bottom:1.2rem;
    right:2.2rem;
  `;
const PassedBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: ${props => props.isPassed ? '#d1fae5' : '#fecdd3'};
  color: ${props => props.isPassed ? '#10b981' : '#ff4352'};
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.875rem;    
  justify-content: space-between;
  
  &::after {
    content: ${props => props.isPassed ? "'✓'" : "'✗'"};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    color: white;
    border-radius: 50%;
    background: ${props => props.isPassed ? '#10b981' : '#ff4352'};
  }
`;

const InfoColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

const InfoSectionTitle = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  color: #9ca3af;
  margin: 0 0 1rem 0;
  text-transform: none;
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
`;

const InfoBox = styled.div`
  background: #f3f5f7;
  border-radius: 12px;
  padding: 1.25rem;
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  position: relative;
`;

const InfoIcon = styled.div`
  position: absolute;
  top: 1.25rem;
  right: 1.25rem;
  font-size: 2rem;
`;

const InfoContent = styled.div`
  flex: 1;
`;

const InfoTitle = styled.div`
  font-size: 1rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 0.5rem;
`;

const InfoSubtitle = styled.div`
  font-size: 0.8rem;
  color: #6b7280;
  margin-bottom: 0.5rem;
  font-weight: 500;
`;

const InfoText = styled.div`
  font-size: 0.85rem;
  font-weight: 500;
  color: #6b7280;
  line-height: 1.6;
`;

const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 98%;
  margin: 0 auto;
  background: rgba(255,255,255,.5);
  border-radius: 0px 0px 12px 12px;
  padding: 1.7rem 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  z-index: 5;
`;

const RulesHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
`;

const RulesTitle = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  color: #111827;
  margin: 0;
`;

const RulesCount = styled.span`
  width: 55px;
  height: 55px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 700;
  color: #111827;
  background-color: rgba(40, 40, 40, 0.05);
`;

const RulesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 4rem;
`;

const RuleCategory = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  justify-content: center;
`;

const RuleCategoryLabel = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: #8e9ebc;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const RuleCount = styled.span`
  font-weight: 700;
  color: #8e9ebc;
`;

const ProgressBar = styled.div`
  width: 100%;
  height: 5px;
  background: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
`;

const ProgressFill = styled.div`
  height: 100%;
  background: ${props => props.color || '#00a1ff'};
  width: ${props => props.percent || 0}%;
  transition: width 0.5s ease;
`;

const ViewAllLink = styled.a`
  color: #00a1ff;
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  text-decoration: underline;
  margin-right:20px;
  
  &:hover {
    text-decoration: underline;
  }
`;

const ValidationGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  
  @media (max-width: 1400px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const ValidationCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 2.7rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const ValidationHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ValidationTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

const ValidationIcon = styled.div`
  font-size: 1.75rem;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  // background: #f3f5f7;
  // border-radius: 12px;
  // border: 1px solid #e5e7eb;
`;

const ValidationName = styled.div`
  font-size: 1.125rem;
  font-weight: 600;
  color: #111827;
`;

const ValidationStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  background-color: ${props => props.isPassed ? '#f0fdf4' : '#fef2f2'};
  color: ${props => props.isPassed ? '#10b981' : '#EF4444'};
  font-size: 1rem;
  font-weight: 600;
  
  &::before {
    content: '●';
    font-size: 1.1rem;
  }
`;

const ValidationMetric = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  padding: 1.5rem;
  background: ${props => props.isPassed 
    ? 'linear-gradient(to top, #f0fdf4, white)' 
    : 'linear-gradient(to top, #fef2f2, white)'};
  border-radius: 12px;
`;

const CircularProgress = styled.div`
  position: relative;
  width: 140px;
  height: 140px;
  flex-shrink: 0;
`;

const CircularProgressText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.25rem;
  font-weight: 700;
  color: #111827;
`;

const MetricIcon = styled.div`
  font-size: 2rem;
`;

const MetricContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

const MetricValue = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: #111827;
`;

const MetricLabel = styled.div`
  font-size: 1.1rem;
  color: #6b7280;
  font-weight: 800;
`;
const MetricSubLabel = styled.div`
  font-size: 1rem;
  color: #6b7280;
  font-weight: 600;
  margin-top: 10px;
`;

const KeyPointsSection = styled.div`
  margin-bottom: auto;
`;

const KeyPointsTitle = styled.div`
  font-size: 0.9rem;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.75rem;
`;

const KeyPoint = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  font-size: 1.1rem;
  font-weight:500;
  color: #374151;
  line-height: 1.5;
  margin-bottom: 0.5rem;
  
  &::before {
    content: '✓';
    color: #10b981;
    font-weight: 600;
    flex-shrink: 0;
  }
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const MoreDetailsButton = styled.button`
  width: auto;
  padding: 0.875rem 2rem;
  background: #f5f5f5;
  border: none;
  margin: 3.5rem auto 0;
  margin-top: auto;
  border-radius: 24px;
  font-size: 0.95rem;
  font-weight: 600;
  color: #333;
  cursor: pointer;
  transition: background 0.2s ease;
  position: relative;
    top: 12px;
  
  &:hover {
    background: #f3f4f6;
    border-color: #d1d5db;
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 2rem;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 16px;
  max-width: 800px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
`;

const ModalHeader = styled.div`
  padding: 2rem;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  background: white;
  z-index: 1;
`;

const ModalTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 700;
  color: #111827;
  margin: 0;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  padding: 0.5rem;
  line-height: 1;
  transition: color 0.2s;
  
  &:hover {
    color: #111827;
  }
`;

const ModalBody = styled.div`
  padding: 2rem;
`;

const RuleCard = styled.div`
  background: #f3f5f7;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const RuleHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
`;

const RuleName = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  color: #111827;
  margin: 0;
`;

const RuleBadge = styled.span`
  padding: 0.25rem 0.75rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  background: ${props => props.result === 'Passed' ? '#d1fae5' : '#fee2e2'};
  color: ${props => props.result === 'Passed' ? '#065f46' : '#991b1b'};
`;

const RuleField = styled.div`
  margin-bottom: 1rem;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const RuleFieldLabel = styled.div`
  font-size: 0.75rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
`;

const RuleFieldValue = styled.div`
  font-size: 0.875rem;
  color: #111827;
  line-height: 1.5;
`;

const RuleMetrics = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
`;

const RuleMetricItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

const RuleMetricLabel = styled.div`
  font-size: 0.75rem;
  color: #6b7280;
  font-weight: 500;
`;

const RuleMetricValue = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: #111827;
`;



const FWARiskDetail = ({ card }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedDimension, setSelectedDimension] = useState(null);

  if (!card) {
    return (
      <DetailContainer>
        <p>No card data available.</p>
      </DetailContainer>
    );
  }

  const fwaData = card?.fwaData;
  const fwaResponse = fwaData?.fwaResponse;
  
  const fwaScore = fwaResponse ? parseInt(fwaResponse.overall_score) : parseInt(card.riskScore) || 35;
  const fwaMaxScore = 100;
  const fwaPercentage = (fwaScore / fwaMaxScore) * 100;
  const fwaCircumference = 2 * Math.PI * 70;
  const fwaOffset = fwaCircumference - (fwaPercentage / 100) * fwaCircumference;
  
  const overallRisk = fwaResponse?.overall_risk || 'Low';
  const overallResult = fwaResponse?.overall_result || 'Passed';
  const caseSummary = fwaResponse?.case_summary || '';
  const caseAnalysis = fwaResponse?.case_analysis || '';
  const dimensions = fwaResponse?.dimensions || [];
  
  const isPassed = overallResult?.toLowerCase().includes('pass') || overallRisk?.toLowerCase() === 'low';
  
  const getStrokeColor = () => {
    if (fwaScore >= 70) return '#EF4444';
    if (fwaScore >= 40) return '#F59E0B';
    return '#10B981';
  };

  const handleOpenModal = (dimension) => {
    setSelectedDimension(dimension);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedDimension(null);
  };

  return (
    <DetailContainer>
      <TopCard>
        {/* Top Section - 3 columns */}
        <TopSection>
          {/* Column 1: Risk Score */}
          <ScoreColumn>
          <SemiCircleProgress>
            <svg width="100%" height="240" viewBox="0 0 200 120">
              <path
                d="M 30 100 A 70 70 0 0 1 170 100"
                fill="none"
                stroke="#E5E7EB"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M 30 100 A 70 70 0 0 1 170 100"
                fill="none"
                stroke={getStrokeColor()}
                strokeWidth="4"
                strokeLinecap="round"
                strokeDasharray={fwaCircumference / 2}
                strokeDashoffset={fwaOffset / 2}
                style={{ transition: 'stroke-dashoffset 1s ease' }}
              />
            </svg>
            <ScoreText>
              <Score>{fwaScore} <MaxScore> Score </MaxScore></Score>
            </ScoreText>
          </SemiCircleProgress>
          <StatusBadge gaugeColor={getStrokeColor()}>{overallResult} Claims</StatusBadge>
          <StatusText>FWA Result: Flagged Appendectomy</StatusText>
           {/* - Risk Level: {overallRisk} FWA Risk Score: {fwaScore}/100*/}
        </ScoreColumn>

        {/* Column 2: Summary */}
        <SummaryColumn>
            <SummaryContent isPassed={isPassed}>
              <SummaryText>
                {caseSummary && <p>{caseSummary.split(/(?=\d+\.\s)/).filter(item => item.trim()).map((item, index) => (
                  <div key={index}>{item.trim()}</div>
                ))}</p>}
                {caseAnalysis && <p>{caseAnalysis}</p>}
              </SummaryText>
              <SummaryTextIcon><img src="/images/fwaDetail/ico-money.png" alt="Info" height="50" /></SummaryTextIcon>
              {/* <PassedBadge isPassed={isPassed}>{overallResult}</PassedBadge> */}
            </SummaryContent>
        </SummaryColumn>

        {/* Column 3: Info Grid */}
        <InfoColumn>
          <InfoSectionTitle>{isPassed ? 'How Risk Was Calculated?' : 'Why Risk is High?'}</InfoSectionTitle>
          <InfoGrid>
            {(isPassed ? [
              {
                title: '5 Days',
                subtitle: 'Within 3-5 Benchmark',
                description: 'Hospital stay aligns with regional pathway standards.',
                icon: '/images/fwaDetail/ico-01.png'
              },
              {
                title: 'Lap Appendectomy',
                subtitle: 'Documented & Billed',
                description: 'Diagnosis and procedure are clinically coherent.',
                icon: '/images/fwaDetail/ico-money-grey.png'
              },
              {
                title: 'No R&C Threshold Breaches',
                subtitle: null,
                description: 'Line items within acceptable pricing range.',
                icon: '/images/fwaDetail/ico-01.png'
              },
              {
                title: 'Low Risk Index',
                subtitle: 'Peer Aligned',
                description: 'Provider shows high rejection history for inconsistent documentation.',
                icon: '/images/fwaDetail/ico-02.png'
              }
            ] : [
                {
                title: '5 Days',
                subtitle: 'Within 3-5 Benchmark',
                description: 'Hospital stay aligns with regional pathway standards.',
                icon: '/images/fwaDetail/ico-01.png'
              },
              {
                title: 'Lap Appendectomy',
                subtitle: 'Documented & Billed',
                description: 'Diagnosis and procedure are clinically coherent.',
                icon: '/images/fwaDetail/ico-01.png'
              },
              {
                title: 'No R&C Threshold Breaches',
                subtitle: null,
                description: 'Line items within acceptable pricing range.',
                icon: '/images/fwaDetail/ico-money-grey.png'
              },
              {
                title: 'Low Risk Index',
                subtitle: 'Peer Aligned',
                description: 'Provider shows high rejection history for inconsistent documentation.',
                icon: '/images/fwaDetail/ico-02.png'
              }
            ]).map((item, index) => (
              <InfoBox key={index}>
                <InfoContent>
                  <InfoTitle>{item.title}</InfoTitle>
                  {item.subtitle && <InfoSubtitle>{item.subtitle}</InfoSubtitle>}
                  <InfoText>{item.description}</InfoText>
                </InfoContent>
                <InfoIcon><img src={item.icon} alt={item.title} height={'33'} /></InfoIcon>
              </InfoBox>
            ))}
          </InfoGrid>
        </InfoColumn>
      </TopSection>

      {/* Bottom Section - Rules */}
      <BottomSection>
        <RulesGrid>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', justifyContent: 'center' }}>
            <RulesCount>85</RulesCount>
            <RulesTitle>Total Rules Run</RulesTitle>
          </div>
          <RuleCategory>
            <RuleCategoryLabel>
              Internal Rules
              <RuleCount>66</RuleCount>
            </RuleCategoryLabel>
            <ProgressBar>
              <ProgressFill percent={100} color="#0abeff" />
            </ProgressBar>
          </RuleCategory>
          <RuleCategory>
            <RuleCategoryLabel>
              AI Engine
              <RuleCount>26</RuleCount>
            </RuleCategoryLabel>
            <ProgressBar>
              <ProgressFill percent={100} color="#0abeff" />
            </ProgressBar>
          </RuleCategory>
          <RuleCategory>
            <RuleCategoryLabel>
              External Service
              <RuleCount>12</RuleCount>
            </RuleCategoryLabel>
            <ProgressBar>
              <ProgressFill percent={100} color="#0abeff" />
            </ProgressBar>
          </RuleCategory>
          <ViewAllLink>All Rule Details</ViewAllLink>
        </RulesGrid>
      </BottomSection>
    </TopCard>

      {/* Validation Cards Grid */}
      <ValidationGrid>
        {dimensions.map((dimension, index) => {
          const dimensionIcons = {
            'Claim': '/assets/images/fwacards/Claim.jpg',
            'Provider': '/assets/images/fwacards/Provider.jpg',
            'Clinical Consistency': '/assets/images/fwacards/Clinical_Consistency.jpg',
            'Billing Analysis': '/assets/images/fwacards/Billing_Analysis.jpg',
            'Claim Roles': '/assets/images/fwacards/Claim_Roles.jpg',
            'Claim History': '/assets/images/fwacards/Claim_History.jpg',
            'Product & Policy': '/assets/images/fwacards/Product_Policy.jpg'
          };
          
          const isDimensionPassed = dimension.overall_result?.toLowerCase() === 'passed';
          
          // Calculate percentage for circular progress (inverse of score - lower score = higher percentage)
          const maxScore = 100;
          const scorePercentage = dimension.overall_score === 0 ? 100 : Math.max(0, 100 - dimension.overall_score);
          const radius = 56;
          const circumference = 2 * Math.PI * radius;
          const offset = circumference - (scorePercentage / 100) * circumference;
          
          // Get primary metric from first rule if available
          const primaryRule = dimension.rules && dimension.rules[0];
          const metricDisplay = primaryRule ? {
            value: primaryRule.score === 0 ? '0%' : `${primaryRule.score}`,
            label: primaryRule.name,
            sublabel: primaryRule.sub_type || ''
          } : {
            value: `${dimension.overall_score}`,
            label: 'Risk Score',
            sublabel: ''
          };
          
          return (
            <ValidationCard key={index}>
              <ValidationHeader>
                <ValidationTitle>
                  <ValidationIcon><img src={dimensionIcons[dimension.name]} alt={dimension.name} width={35} /></ValidationIcon>
                  <ValidationName>{dimension.name}</ValidationName>
                </ValidationTitle>
                <ValidationStatus isPassed={isDimensionPassed}>{dimension.overall_result}</ValidationStatus>
              </ValidationHeader>
              
              <ValidationMetric isPassed={isDimensionPassed}>
                <CircularProgress>
                  <svg width="140" height="140" viewBox="0 0 140 140">
                    <circle
                      cx="70"
                      cy="70"
                      r={radius}
                      fill="none"
                      stroke="#E5E7EB"
                      strokeWidth="6"
                    />
                    <circle
                      cx="70"
                      cy="70"
                      r={radius}
                      fill="none"
                      stroke={isDimensionPassed ? '#10b981' : '#EF4444'}
                      strokeWidth="6"
                      strokeDasharray={circumference}
                      strokeDashoffset={offset}
                      strokeLinecap="round"
                      transform="rotate(-90 70 70)"
                      style={{ transition: 'stroke-dashoffset 0.5s ease' }}
                    />
                  </svg>
                  <CircularProgressText>{scorePercentage}%</CircularProgressText>
                </CircularProgress>
                
                <MetricContent>
                  {/* <MetricValue>{metricDisplay.value}</MetricValue> */}
                  <MetricLabel>{metricDisplay.label}</MetricLabel>
                  {/* {metricDisplay.sublabel && <MetricSubLabel>Sub-type: {metricDisplay.sublabel}</MetricSubLabel>} */}
                  {dimension.rules && dimension.rules.length > 0 && (
                  <MetricSubLabel 
                    title={dimension.rules.map(r => r.rule).join('\n')}
                  >
                    {dimension.rules[0].rule && dimension.rules[0].rule.length > 60
                      ? `${dimension.rules[0].rule.substring(0, 60)}...` 
                      : dimension.rules[0].rule}
                  </MetricSubLabel>
                )}
                </MetricContent>
              </ValidationMetric>
              
              <KeyPointsSection>
                <KeyPointsTitle>Key points</KeyPointsTitle>
                {dimension.rules && dimension.rules.map((rule, ruleIndex) => (
                  <KeyPoint key={ruleIndex}>
                    {rule.reason}
                  </KeyPoint>
                ))}
              </KeyPointsSection>
              
              <MoreDetailsButton onClick={() => handleOpenModal(dimension)}>More Details</MoreDetailsButton>
            </ValidationCard>
          );
        })}
        
        {/* Fallback: Show old hardcoded card if no dimensions */}
        {dimensions.length === 0 && (
          <ValidationCard>
            <ValidationHeader>
              <ValidationTitle>
                <ValidationIcon>📄</ValidationIcon>
                <ValidationName>Claim</ValidationName>
              </ValidationTitle>
              <ValidationStatus>Pass</ValidationStatus>
            </ValidationHeader>
            <ValidationMetric>
              <MetricIcon>✓</MetricIcon>
              <div>
                <MetricValue>3 Years</MetricValue>
                <MetricLabel>Since Policy Start</MetricLabel>
                <MetricLabel style={{ marginTop: '0.25rem' }}>Waiting Period Cleared</MetricLabel>
              </div>
            </ValidationMetric>
            <KeyPointsSection>
              <KeyPointsTitle>Key points</KeyPointsTitle>
              <KeyPoint>Policy Tenure Validation: Claim timing does not fall within early-claim or end-of-policy risk windows.</KeyPoint>
              <KeyPoint>Hospitalization Consistency: Admission and discharge duration align with the expected treatment timeline.</KeyPoint>
            </KeyPointsSection>
            <MoreDetailsButton>More Details</MoreDetailsButton>
          </ValidationCard>
        )}
      </ValidationGrid>

      {/* Modal for Rule Details */}
      {modalOpen && selectedDimension && (
        <ModalOverlay onClick={handleCloseModal}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <ModalTitle>{selectedDimension.name} - Detailed Rules</ModalTitle>
              <CloseButton onClick={handleCloseModal}>×</CloseButton>
            </ModalHeader>
            <ModalBody>
              {selectedDimension.rules && selectedDimension.rules.map((rule, index) => (
                <RuleCard key={index}>
                  <RuleHeader>
                    <RuleName>{rule.name}</RuleName>
                    <RuleBadge result={rule.result}>{rule.result}</RuleBadge>
                  </RuleHeader>
                  
                  <RuleField>
                    <RuleFieldLabel>Rule</RuleFieldLabel>
                    <RuleFieldValue>{rule.rule}</RuleFieldValue>
                  </RuleField>
                  
                  <RuleField>
                    <RuleFieldLabel>Description</RuleFieldLabel>
                    <RuleFieldValue>{rule.description}</RuleFieldValue>
                  </RuleField>
                  
                  <RuleField>
                    <RuleFieldLabel>Reason</RuleFieldLabel>
                    <RuleFieldValue>{rule.reason}</RuleFieldValue>
                  </RuleField>
                  
                  <RuleMetrics>
                    <RuleMetricItem>
                      <RuleMetricLabel>Type</RuleMetricLabel>
                      <RuleMetricValue>{rule.type}</RuleMetricValue>
                    </RuleMetricItem>
                    <RuleMetricItem>
                      <RuleMetricLabel>Sub Type</RuleMetricLabel>
                      <RuleMetricValue>{rule.sub_type}</RuleMetricValue>
                    </RuleMetricItem>
                    <RuleMetricItem>
                      <RuleMetricLabel>Score</RuleMetricLabel>
                      <RuleMetricValue>{rule.score}</RuleMetricValue>
                    </RuleMetricItem>
                    <RuleMetricItem>
                      <RuleMetricLabel>Weightage</RuleMetricLabel>
                      <RuleMetricValue>{rule.weightage}</RuleMetricValue>
                    </RuleMetricItem>
                  </RuleMetrics>
                </RuleCard>
              ))}
            </ModalBody>
          </ModalContent>
        </ModalOverlay>
      )}
    </DetailContainer>
  );
};

export default FWARiskDetail;
